var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgParkedOrderIcon = function SvgParkedOrderIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4E9700",
    d: "M5.263 0C2.361 0 0 2.36 0 5.263c0 2.902 2.36 5.263 5.263 5.263 2.902 0 5.263-2.36 5.263-5.263C10.526 2.361 8.166 0 5.263 0z",
    transform: "translate(6 6) translate(9.419 7.978)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M7.93 4.148l-2.85 2.85c-.086.086-.198.13-.31.13-.113 0-.225-.044-.31-.13L3.034 5.574c-.171-.171-.171-.448 0-.62.172-.171.449-.171.62 0L4.77 6.068l2.54-2.54c.172-.172.45-.172.62 0 .172.171.172.448 0 .62z",
    transform: "translate(6 6) translate(9.419 7.978)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#6D7278",
    d: "M6.782 4.756l1.233-.516c.15-.063.32-.063.47 0l1.232.516V.019H6.782v4.737z",
    transform: "translate(6 6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#604325",
    d: "M14.682 6.748c.63 0 1.24.091 1.817.26V1.514c0-.824-.67-1.495-1.494-1.495h-4.071V5.67c0 .204-.102.394-.272.506-.101.068-.218.102-.337.102-.08 0-.159-.015-.235-.047l-1.84-.77-1.841.77c-.188.079-.403.058-.572-.055-.17-.112-.272-.302-.272-.506V.02h-4.07C.67.02 0 .69 0 1.513v13.51c0 .824.67 1.495 1.495 1.495h7.608c-.572-.966-.9-2.09-.9-3.291 0-3.573 2.906-6.48 6.479-6.48z",
    transform: "translate(6 6)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgParkedOrderIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/parked_order_icon.edeebd3c.svg";
export { ForwardRef as ReactComponent };